import { render } from "./TicketWaitingV2.vue?vue&type=template&id=02c64bbe&scoped=true&class=w-100"
import script from "./TicketWaitingV2.vue?vue&type=script&lang=js"
export * from "./TicketWaitingV2.vue?vue&type=script&lang=js"

import "./TicketWaitingV2.vue?vue&type=style&index=0&id=02c64bbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c64bbe"]])

export default __exports__